<template>
  <div>
    <div
      v-if="!datasReady"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <a-form
      v-else
      ref="inviteForm"
      layout="inline"
      :form="form"
      class="collect-form"
      @submit.prevent="submitHandle"
    >
      <div class="dev-config-box">
        <a-form-item label="开发人员">
          <a-switch
            v-decorator="['isneeded', {initialValue: !!devDatas.other.isneeded}]"
            :checked="devDatas.other.isneeded === 1"
            @change="changeSwitch"
          />
          <span
            class="switch-text"
            v-text="devDatas.other.isneeded === 1 ? '开启必填' : '关闭必填'"
          />
        </a-form-item>
      </div>
      <div
        v-for="(item,index) in datas"
        :key="item.id"
      >
        <item
          :data-info="item"
          :data-index="index"
          :form="form"
        />
      </div>
      <div class="add-config-btn-box">
        <add-layout-form type="add" />
      </div>
      <div
        ref="footerBtn"
        class="footer-wrap"
      >
        <div
          ref="footer"
          class="footer"
          :class="{'ani':isShowBtn}"
        >
          <a-button
            type="primary"
            html-type="submit"
            :disabled="isBtnDisable"
            :loading="submitting"
          >
            {{ $t('message["21"]') }}
          </a-button>
          <!-- <a-button @click="handleCancel">
            取消
          </a-button> -->
          <span class="sub-tip">{{ $t('message["22"]') }}？</span>
        </div>
      </div>
    </a-form>
  </div>
</template>
<script>
import Item from './item/Item'
import AddLayoutForm from './AddLayoutForm'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    Item,
    AddLayoutForm
  },
  data () {
    return {
      isShowBtn: false,
      counter: 1,
      submitting: false
    }
  },
  provide () {
    return {
      myForm: this
    }
  },
  computed: {
    ...mapState('config/collect', ['datas', 'devDatas', 'datasReady', 'areaDatas', 'isBtnDisable'])
  },
  watch: {
    datasReady (val) {
      if (val) {
        this.setFooterStyle()
      }
    },
    datas: {
      handler (val) {
        this.counter++
        if (val && this.counter > 3) {
          this.isShowBtn = true
          this.setFooterStyle()
        }
      },
      deep: true
    },
    devDatas: {
      handler (val) {
        this.counter++
        if (val && this.counter > 3) {
          this.isShowBtn = true
          this.setFooterStyle()
        }
      },
      deep: true
    }
  },
  created () {
    this.form = this.$form.createForm(this)
    this.setFooterStyle()
    window.addEventListener('resize', this.setFooterStyle)
    document.addEventListener('scroll', this.setFooterStyle)
  },
  async mounted () {
    const chain = await this.fetchCollectDatas()
    chain.params({ type: 2 })
      .onSuccess(() => {
        document.title = this.$t('message["1173"]') + ' - ' + this.$store.state.baseinfo.projectname + '-' + this.$store.state.baseinfo.comname
      })
      .fetch()
    await this.fetchDevDatas({ type: 21 })
    const chain2 = await this.fetchAreaDatas()
    chain2.fetch()
  },
  methods: {
    ...mapActions('config/collect', ['fetchCollectDatas', 'fetchAreaDatas', 'subCollect', 'removeClick', 'fetchDevDatas']),
    submitHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.deleteId(this.datas)
          this.submitting = true
          const chain = await this.subCollect()
          chain.params({ submit: this.datas, ...this.devDatas })
            .onSuccess(async (res) => {
              this.removeClick()
              if (res.type) {
                this.$confirm({
                  type: 'success',
                  title: this.$t('message["23"]'),
                  content: this.$t('message["696"]'),
                  okText: this.$t('message["598"]'),
                  okType: 'primary',
                  cancelText: this.$t('message["1005"]'),
                  iconType: 'check-circle',
                  centered: true,
                  // closable: true,
                  onOk: () => {
                    this.$router.push({ name: 'RoleManagement' })
                  },
                  onCancel: () => {
                    location.reload()
                  }
                })
              } else {
                this.$message.success(`${this.$t('message["23"]')}！`)
                setTimeout(() => {
                  location.reload()
                }, 1000)
              }
            })
            .onNetSuccess((res) => {
              this.submitting = false
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    deleteId (arr) {
      arr.forEach((item, index) => {
        if (item._id) {
          delete item._id
        }
        if (item.fieldtype === 'select_tree') {
          this.delTree(item.options)
        }
        if (item.options2) {
          delete item.options2
        }
        if (item.child && item.child.length) {
          this.deleteId(item.child)
        }
      })
    },
    delTree (arr) {
      arr.forEach((item, index) => {
        delete item.title
        delete item.scopedSlots
        delete item.key
        delete item.addShow
        if (item._id) {
          delete item._id
        }
        if (item.options && item.options.length) {
          item.options.forEach(item => {
            if (item._id) {
              delete item._id
            }
          })
        }
        if (item.children && item.children.length) {
          this.delTree(item.children)
        }
      })
    },
    setFooterStyle () {
      this.$nextTick(() => {
        if (!this.$refs.footer) return

        const $footer = this.$refs.footer

        $footer.style.width = $footer.parentNode.offsetWidth + 40 * 2 + 'px'
        // console.log(getScrollTop(), $footer.parentNode, $footer.parentNode.offsetTop)
        const sectionWidth = this.$getSectionWidth()
        const pageWidth = this.$getPageSize().pageWidth
        // console.log(sectionWidth, pageWidth, $footer.parentNode.offsetLeft)
        if ($footer.parentNode.offsetTop - this.$getScrollTop() - window.innerHeight + $footer.parentNode.offsetHeight + 44 < 0) {
          $footer.style.position = 'relative'
          $footer.style.left = 0
        } else {
          $footer.style.position = 'fixed'
          $footer.style.left = pageWidth <= sectionWidth ? $footer.parentNode.offsetLeft + 1 + 'px' : $footer.parentNode.offsetLeft + (pageWidth - sectionWidth) / 2 + 1 + 'px'
        }
      })
    },
    changeSwitch (val) {
      this.devDatas.other.isneeded = val ? 1 : 0
    }
  }
}
</script>
<style lang="scss" scoped>
.footer-wrap {
    height: 64px;
    margin-top: 40px;
  }
  .footer {
    position: fixed;
    bottom: -89px;
    left: 0;
    height: 64px;;
    z-index: 999;
    margin-left: -40px;
    padding: 16px 80px;
    background-color: #fff;
    border-top: solid 1px $gray4;
    transition: bottom 0.5s linear;
    .ant-btn {
      margin-right: 0 ;
    }
    span.sub-tip {
      color: #b3b3b3;
      margin-left: 10px;
    }
   opacity: 0;
  }
  .ani {
    bottom: 0;
    opacity: 1;
  }
  .dev-config-box::v-deep{
    margin: 20px 0 -17px;
    background: #fafafa;
    padding: 32px 32px 30px 35px;
    border-top: 1px solid #ebebeb;
    .ant-form-item-label{
      color: #333 !important;
      margin-right: 24px;
      label::after{
        content: ''
      }
    }
    .switch-text{
      margin-left: 8px;
    }
  }
</style>
